import { render, staticRenderFns } from "./CustomViewBuilder.vue?vue&type=template&id=f06d6be8&scoped=true&"
import script from "./CustomViewBuilder.vue?vue&type=script&lang=js&"
export * from "./CustomViewBuilder.vue?vue&type=script&lang=js&"
import style0 from "./CustomViewBuilder.vue?vue&type=style&index=0&id=f06d6be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06d6be8",
  null
  
)

export default component.exports